/******/
(() => { // webpackBootstrap
    /******/
    "use strict";
    /******/
    var __webpack_modules__ = ({

        /***/ "../src/js/custom/modal_form.js":
        /*!*********************************!*\
          !*** ../src/js/custom/modal_form.js ***!
          \*********************************/
        /***/ ((module) => {


// Class definition
            var KTModalForm = function () {
                // Public methods
                return {
                    init: function () {
                        $('[data-bs-modal=auto][data-bs-target-url]').on('click', function (e) {
                            e.preventDefault();
                            let $modalPanel = $(this);
                            let settings = {
                                dataURL: $modalPanel.attr('data-bs-target-url'),
                                formURL: null,
                                modalContent: ".modal-content",
                                modalForm: ".modal-content form",
                                modalID: "#kt_base_modal",
                                submitBtn: ".modal-footer [type=submit]",
                                callAjax: $modalPanel.attr('data-bs-call-ajax') !== undefined,
                            }

                            $(settings.modalID).load(settings.dataURL, function () {
                                $(settings.modalID).modal("show");
                                settings.formURL = $(this).find(settings.modalForm).attr("action");

                                if (settings.formURL === undefined || settings.formURL === '') {
                                    settings.formURL = settings.dataURL;
                                }

                                $(settings.modalForm).attr("action", settings.formURL);
                                addEventHandlers(settings);
                            });
                        });

                        var addEventHandlers = function (settings) {
                            $(settings.modalForm).on("submit", function (event) {
                                if (event.originalEvent !== undefined && settings.callAjax === true) {
                                    event.preventDefault();
                                    isFormValid(settings, submitForm);
                                    return false;
                                }
                            });
                            // Modal close handler
                            $(settings.modalID).on("hidden.bs.modal", function (event) {
                                $(settings.modalForm).remove();
                            });
                        };

                        // Check if form.is_valid() & either show errors or submit it via callback
                        var isFormValid = function (settings, callback) {
                            $.ajax({
                                type: $(settings.modalForm).attr("method"),
                                url: $(settings.modalForm).attr("action"),
                                data: new FormData($(settings.modalForm)[0]),
                                contentType: false,
                                processData: false,
                                beforeSend: function () {
                                    $(settings.submitBtn).prop("disabled", true);
                                },
                                success: function (response) {
                                    if ($(response).find(settings.errorClass).length > 0) {
                                        // Form is not valid, update it with errors
                                        $(settings.modalID).find(settings.modalContent).html(response);
                                        $(settings.modalForm).attr("action", settings.formURL);
                                        // Re-instantiate handlers
                                        addEventHandlers(settings);
                                    } else {
                                        // Form is valid, submit it
                                        callback(settings);
                                    }
                                }
                            });
                        };

                        var submitForm = function (settings) {
                            $(settings.modalForm).submit();
                        };
                    }
                }
            }();

// Webpack support
            if (true) {
                module.exports = KTModalForm;
            }

// On document ready
            KTUtil.onDOMContentLoaded(function () {
                KTModalForm.init();
            });


            /***/
        })

        /******/
    });
    /************************************************************************/
    /******/ 	// The module cache
    /******/
    var __webpack_module_cache__ = {};
    /******/
    /******/ 	// The require function
    /******/
    function __webpack_require__(moduleId) {
        /******/ 		// Check if module is in cache
        /******/
        var cachedModule = __webpack_module_cache__[moduleId];
        /******/
        if (cachedModule !== undefined) {
            /******/
            return cachedModule.exports;
            /******/
        }
        /******/ 		// Create a new module (and put it into the cache)
        /******/
        var module = __webpack_module_cache__[moduleId] = {
            /******/ 			// no module.id needed
            /******/ 			// no module.loaded needed
            /******/            exports: {}
            /******/
        };
        /******/
        /******/ 		// Execute the module function
        /******/
        __webpack_modules__[moduleId](module, module.exports, __webpack_require__);
        /******/
        /******/ 		// Return the exports of the module
        /******/
        return module.exports;
        /******/
    }

    /******/
    /************************************************************************/
    /******/
    /******/ 	// startup
    /******/ 	// Load entry module and return exports
    /******/ 	// This entry module is referenced by other modules so it can't be inlined
    /******/
    var __webpack_exports__ = __webpack_require__("../src/js/custom/modal_form.js");
    /******/
    /******/
})()
;
//# sourceMappingURL=modal_form.js.map
